import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "id", "type", "value", "placeholder"]

import { toRef } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TextareaInput',
  props: {
    type: {
        type: String,
        default: "text",
    },
    value: {
        type: String,
        default: "",
    },
    modelValue: {
        type: String,
        default: "",
        required: false,
    },
    name: {
        type: String,
        required: true,
    },
    error: {
        type: String,
        default: null,
    },
    successMessage: {
        type: String,
        default: "",
    },
    placeholder: {
        type: String,
        default: "",
    },
    maxLength: {
        type: Number,
        default: null,
    },
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const name = toRef(props, "name");

const onHandlerChange = ($event) => {
    emit("update:modelValue", props.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("textarea", {
      name: name.value,
      id: name.value,
      type: __props.type,
      value: props.modelValue,
      class: _normalizeClass(["form-control rounded", { 'is-invalid': !!__props.error}]),
      placeholder: __props.placeholder,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event.target.value)))
    }, null, 42, _hoisted_1),
    _withDirectives(_createElementVNode("span", {
      class: "invalid-feedback",
      role: "alert"
    }, _toDisplayString(__props.error), 513), [
      [_vShow, __props.error]
    ])
  ], 64))
}
}

})